export default __webpack_public_path__ + "static/media/messagealert.64ff85dd.svg";